<script setup>
import { mentorData } from '../../config/pageData.js';
</script>

<template>
  <section class="m-sec m-sec-paper2">
    <div class="m-photo">
      <img
        :src="mentorData.image"
        alt="楓燧大師兄"
        class="m-photo-img"
        loading="lazy"
      />
    </div>
    <div class="m-center">
      <span class="m-kicker">{{ mentorData.kicker }}</span>
    </div>
    <h3 class="m-name">
      {{ mentorData.name }}
      <span class="m-alias">{{ mentorData.alias }}</span>
    </h3>
    <div class="m-honor">{{ mentorData.honor }}</div>
    <ul class="m-list">
      <li
        v-for="(p, i) in mentorData.points"
        :key="i"
        class="m-item"
      >
        {{ p }}
      </li>
    </ul>
  </section>
</template>

<style scoped lang="scss">
.m-sec {
  padding: 96px 32px;
}

.m-sec-paper2 {
  background: #efe8d8;
}

.m-photo {
  max-width: 560px;
  margin: 0 auto 40px;
}

.m-photo-img {
  width: 100%;
  aspect-ratio: 4 / 5;
  object-fit: cover;
  border-radius: 18px;
  display: block;
}

.m-center {
  text-align: left;
}

.m-kicker {
  display: inline-block;
  font-size: 24px;
  letter-spacing: 8px;
  color: #a8823f;
  border: 2px solid #c9a25e;
  padding: 8px 24px;
  border-radius: 999px;
  margin-bottom: 24px;
}

.m-name {
  font-size: 44px;
  font-weight: 700;
  color: #16241d;
  text-align: left;
  letter-spacing: 2px;
}

.m-alias {
  font-size: 26px;
  color: #6f6a5c;
  font-weight: 400;
}

.m-honor {
  color: #a8823f;
  font-size: 25px;
  text-align: left;
  margin: 14px 0 28px;
}

.m-list {
  display: grid;
}

.m-item {
  position: relative;
  padding: 18px 0 18px 32px;
  font-size: 27px;
  color: #46443c;
  border-bottom: 1px dashed #ddd4bd;

  &:last-child {
    border-bottom: none;
  }

  &::before {
    content: '◆';
    position: absolute;
    left: 4px;
    top: 22px;
    color: #c9a25e;
    font-size: 20px;
  }
}
</style>
